import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { TopUpStackRoutes, TopUpStackScreenProps } from './type';
import { TopUpWebTwoScreen } from './TopUpWebTwo.screen';
import { TopUpNativeTwoScreen } from './TopUpNativeTwo.screen';

export interface NewAccountProps {}
export const TopUpPlaced: React.FC<TopUpStackScreenProps<TopUpStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, returnData, refresh, record } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <TopUpNativeTwoScreen onClose={onGoBack} data={data} returnData={returnData} refresh={refresh} record={record} />;
  }

  return (
    <TopUpWebTwoScreen onClose={closeModal} onLayout={onLayout} data={data} returnData={returnData} refresh={refresh} record={record} />
  );
};
